import { withKey, withoutKey } from 'piral-core';
export function registerMenuItem(ctx, name, value) {
    ctx.dispatch((state) => ({
        ...state,
        registry: {
            ...state.registry,
            menuItems: withKey(state.registry.menuItems, name, value),
        },
    }));
}
export function unregisterMenuItem(ctx, name) {
    ctx.dispatch((state) => ({
        ...state,
        registry: {
            ...state.registry,
            menuItems: withoutKey(state.registry.menuItems, name),
        },
    }));
}
//# sourceMappingURL=actions.js.map